import {
  FIXTURE_ACTION_TYPE,
  MATCH_ACTION_SEND_TYPE,
  SPORT_ID,
} from '@/service/constants';
import {
  FixtureAction,
  FixtureConfig,
  FixtureConfigSport,
} from '@/service/types';

interface GetOptionalPeriodNameProps {
  period: number;
  fixtureConfig: FixtureConfig | undefined;
  fixtureSeqNum: number;
  actions?: FixtureAction[];
}

interface GetPeriodNameProps extends GetOptionalPeriodNameProps {
  currentSport?: FixtureConfigSport;
}

export const getPeriodName = ({
  period,
  fixtureConfig,
  currentSport,
  fixtureSeqNum,
  actions,
}: GetPeriodNameProps) => {
  if (currentSport && currentSport?.id !== SPORT_ID.SOCCER)
    return period.toString();

  return getOptionalPeriodName({
    period,
    fixtureConfig,
    fixtureSeqNum,
    actions,
  });
};

export const getOptionalPeriodName = ({
  period,
  fixtureConfig,
  fixtureSeqNum,
  actions,
}: GetOptionalPeriodNameProps) => {
  const optionalPeriodNum =
    actions?.find(
      (action) =>
        action.fixtureActionTypeId === FIXTURE_ACTION_TYPE.END_PERIOD &&
        action.fixtureSeqNum < fixtureSeqNum &&
        action.metadata?.requestedOptionalPeriodSequenceNumber,
    )?.metadata.requestedOptionalPeriodSequenceNumber || period;

  const action = actions?.find(
    (action) => action.fixtureSeqNum === fixtureSeqNum,
  );

  if (
    action &&
    action.period < optionalPeriodNum &&
    (action.sendTypeId === MATCH_ACTION_SEND_TYPE.UPDATED ||
      action.sendTypeId === MATCH_ACTION_SEND_TYPE.DELETED)
  ) {
    if (action.period < optionalPeriodNum && action.period > 2) {
      const isOptionalPeriodNumEqualToActionPeriod = !!actions?.find(
        (action) =>
          action.fixtureActionTypeId === FIXTURE_ACTION_TYPE.END_PERIOD &&
          action.fixtureSeqNum < fixtureSeqNum &&
          action.metadata?.requestedOptionalPeriodSequenceNumber === period,
      );

      return (
        fixtureConfig?.fixtureOptions.sportRules.periodDetails.find(
          ({ seq }) =>
            !isOptionalPeriodNumEqualToActionPeriod
              ? seq === optionalPeriodNum
              : seq === period,
        )?.label || period.toString()
      );
    }

    return (
      fixtureConfig?.fixtureOptions.sportRules.periodDetails.find(
        ({ seq }) => seq === period,
      )?.label || period.toString()
    );
  }

  return (
    fixtureConfig?.fixtureOptions.sportRules.periodDetails.find(({ seq }) =>
      optionalPeriodNum >= period ? seq === optionalPeriodNum : seq === period,
    )?.label || period.toString()
  );
};
